import * as Scrivito from "scrivito";

Scrivito.provideComponent("GlobalConfigPage", ({ page }) => (
  <Scrivito.ContentTag tag="div" content={page} attribute="body" />
));
